export default __webpack_public_path__ + "static/media/mastercard.8b99341e.svg";